const routes = {
    profile: "/profiles",
    browse: "/browse",
}


export default routes;